import React from "react";
import { motion } from "framer-motion";
import portfolio from "@/data/portfolio";

export default function Expertise() {
  return (
    <section
      id="expertise"
      data-testid="expertise-section"
      className="py-24 md:py-40 border-t hairline bg-[#FAFAFA]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="mb-14 max-w-3xl">
          <div className="flex items-center gap-3 mb-6">
            <span className="inline-block w-8 h-px bg-black/40" />
            <span className="text-xs font-semibold uppercase tracking-[0.22em] text-gray-500">
              07 · Equestrian expertise
            </span>
          </div>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-black leading-[1.05]">
            Domain depth across the full equestrian value chain.
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {portfolio.expertise.map((e, i) => (
            <motion.div
              key={e.title}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.04 }}
              data-testid={`expertise-card-${i}`}
              className="group bg-white border hairline rounded-3xl p-6 md:p-8 lg:p-10 hover:-translate-y-1 hover:shadow-xl hover:shadow-black/5 transition-all duration-400"
            >
              <div className="text-[10px] md:text-xs font-semibold uppercase tracking-[0.22em] text-gray-400">
                {String(i + 1).padStart(2, "0")}
              </div>
              <div className="mt-3 md:mt-4 font-serif-display text-xl md:text-2xl lg:text-3xl text-black tracking-tight">
                {e.title}
              </div>
              <p className="mt-2 md:mt-3 text-sm md:text-base text-gray-600 font-light leading-relaxed">
                {e.desc}
              </p>
              <div className="mt-6 h-px bg-black/0 group-hover:bg-black/10 transition-colors" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
